type Alpha2CountryCode = ReturnType<typeof getEstimatedUserCountry>;

const countryToCurrencyMap: Partial<
  Record<NonNullable<Alpha2CountryCode>, string>
> = {
  // British Pound
  GB: "GBP",

  // US Dollar
  US: "USD",
  CA: "USD",

  // Chinese Yuan
  CN: "CNY",

  // Japanese Yen
  JP: "JPY",

  // Euro
  AT: "EUR",
  BE: "EUR",
  BG: "EUR",
  HR: "EUR",
  CY: "EUR",
  CZ: "EUR",
  DK: "EUR",
  EE: "EUR",
  FI: "EUR",
  FR: "EUR",
  DE: "EUR",
  GR: "EUR",
  HU: "EUR",
  IE: "EUR",
  IT: "EUR",
  LV: "EUR",
  LT: "EUR",
  LU: "EUR",
  MT: "EUR",
  NL: "EUR",
  PL: "EUR",
  PT: "EUR",
  RO: "EUR",
  SK: "EUR",
  SI: "EUR",
  ES: "EUR",

  // Turkish Lira
  TR: "TRY",

  // Brazilian Real
  BR: "BRL",

  // Indian Rupee
  ID: "INR",

  // Argentinian Peso
  AR: "ARS",

  // Australian Dollar
  AU: "AUD",

  // New Zealand Dollar
  NZ: "NZD",

  // South Korean Won
  KR: "KRW",
};

export default (countryCode: Alpha2CountryCode) => {
  if (!countryCode) {
    return null;
  }

  return countryToCurrencyMap[countryCode] ?? null;
};
